// extracted by mini-css-extract-plugin
module.exports = {"fileNameWrap":"NameBlock_fileNameWrap__3sHhw","fileName":"NameBlock_fileName__1gdUy","fileType":"NameBlock_fileType__36MPX","accent":"NameBlock_accent__3B4Bc"};